import { render } from "./Pills.vue?vue&type=template&id=fe4ad7bc"
import script from "./Pills.vue?vue&type=script&lang=js"
export * from "./Pills.vue?vue&type=script&lang=js"

import "./Pills.vue?vue&type=style&index=0&id=fe4ad7bc&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__